"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.i18n = exports.dateFormats = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _ar = _interopRequireDefault(require("./ar/ar.json"));
var _es = _interopRequireDefault(require("./es/es.json"));
var _en_GB = _interopRequireDefault(require("./en_GB/en_GB.json"));
var _en_AU = _interopRequireDefault(require("./en_AU/en_AU.json"));
var _en_US = _interopRequireDefault(require("./en_US/en_US.json"));
var _fr = _interopRequireDefault(require("./fr/fr.json"));
var _fr_CA = _interopRequireDefault(require("./fr_CA/fr_CA.json"));
var _index = _interopRequireDefault(require("./date-formats/locale/es/index.js"));
var _index2 = _interopRequireDefault(require("./date-formats/locale/es_CL/index.js"));
var _index3 = _interopRequireDefault(require("./date-formats/locale/es_CO/index.js"));
var _index4 = _interopRequireDefault(require("./date-formats/locale/es_DO/index.js"));
var _index5 = _interopRequireDefault(require("./date-formats/locale/es_EC/index.js"));
var _index6 = _interopRequireDefault(require("./date-formats/locale/es_MX/index.js"));
var _index7 = _interopRequireDefault(require("./date-formats/locale/es_PE/index.js"));
var _index8 = _interopRequireDefault(require("./date-formats/locale/es_PR/index.js"));
var i18n = exports.i18n = {
  ar: (0, _extends2.default)({}, _ar.default),
  en_US: (0, _extends2.default)({}, _en_US.default),
  en_GB: (0, _extends2.default)({}, _en_GB.default),
  en_AU: (0, _extends2.default)({}, _en_AU.default),
  es: (0, _extends2.default)({}, _es.default),
  es_CL: (0, _extends2.default)({}, _es.default),
  es_MX: (0, _extends2.default)({}, _es.default),
  es_CO: (0, _extends2.default)({}, _es.default),
  es_EC: (0, _extends2.default)({}, _es.default),
  es_PE: (0, _extends2.default)({}, _es.default),
  es_DO: (0, _extends2.default)({}, _es.default),
  es_PR: (0, _extends2.default)({}, _es.default),
  fr: (0, _extends2.default)({}, _fr.default),
  fr_CA: (0, _extends2.default)({}, _fr_CA.default)
};
var dateFormats = exports.dateFormats = {
  es: _index.default,
  esCL: _index2.default,
  esCO: _index3.default,
  esDO: _index4.default,
  esEC: _index5.default,
  esMX: _index6.default,
  esPE: _index7.default,
  esPR: _index8.default
};